import { apiClient } from './api';
import { API_ENDPOINTS } from '../constants';

export const licenseService = {
  async getLicenses(filters) {
    const params = new URLSearchParams();
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.LICENSES}?${queryString}` : API_ENDPOINTS.LICENSES;
    
    const response = await apiClient.get(endpoint);
    
    // Extraer los datos de la respuesta estructurada
    if (response && response.success && response.data) {
      return response.data;
    }
    
    // Fallback: si la respuesta no tiene la estructura esperada, devolver la respuesta completa
    return response || [];
  },

  async getLicense(id) {
    const response = await apiClient.get(API_ENDPOINTS.LICENSE_DETAIL(id));
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async createLicense(data) {
    const response = await apiClient.post(API_ENDPOINTS.LICENSES, data);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async updateLicense(id, data) {
    const response = await apiClient.put(API_ENDPOINTS.LICENSE_DETAIL(id), data);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async deleteLicense(id) {
    return apiClient.delete(API_ENDPOINTS.LICENSE_DETAIL(id));
  },

  /**
   * Libera un cupo: elimina la instalación (PC) asociada a la licencia.
   * Decrementa current_installations en el backend.
   */
  async releaseInstallation(licenseId, installationId) {
    const response = await apiClient.delete(
      API_ENDPOINTS.LICENSE_RELEASE_INSTALLATION(licenseId, installationId)
    );
    if (response && response.success) {
      return response;
    }
    return response;
  },

  async generateLicense(data) {
    const response = await apiClient.post(API_ENDPOINTS.LICENSE_GENERATE, data);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async validateLicense(licenseKey, machineId) {
    const response = await apiClient.post(API_ENDPOINTS.LICENSE_VALIDATE, {
      license_key: licenseKey,
      machine_id: machineId
    });
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async getLicenseStatus(licenseKey) {
    const response = await apiClient.get(API_ENDPOINTS.LICENSE_STATUS(licenseKey));
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async bulkUpdateLicenses(ids, updates) {
    return apiClient.patch(`${API_ENDPOINTS.LICENSES}bulk_update/`, {
      ids,
      updates,
    });
  },

  async exportLicenses(filters) {
    const params = new URLSearchParams();
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.LICENSES}export/?${queryString}` : `${API_ENDPOINTS.LICENSES}export/`;
    
    const response = await fetch(`${apiClient['baseURL']}${endpoint}`, {
      headers: {
        'Authorization': `Bearer ${apiClient.getToken()}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to export licenses');
    }
    
    return response.blob();
  },

  async getValidationLogs(filters) {
    const params = new URLSearchParams();

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }

    const queryString = params.toString();
    const endpoint = queryString
      ? `${API_ENDPOINTS.VALIDATION_LOGS}?${queryString}`
      : API_ENDPOINTS.VALIDATION_LOGS;

    const response = await apiClient.get(endpoint);

    if (response && response.success && response.data) {
      return response.data;
    }

    return response || [];
  },
};